import styled from 'styled-components'
import { assets } from '../../assets'
import { colors } from '../../enums'
import { BORDER, FLEX, FONT } from '../../utils'

export const Container = styled.div`
   display: inline-flex;
   position: relative;
`

export const DateInputTemplate = styled.input.attrs({ type: 'date' })`
   width: 150px;
   height: 45px;

   ${BORDER({ color: colors.lighter_grey })}
   border-radius: 8px;
   padding-left: 46px;

   ${FONT({ color: colors.grey, size: '16px' })}
   position:relative;

   &::-webkit-calendar-picker-indicator {
      background: transparent;
      bottom: 0;
      color: transparent;
      cursor: pointer;
      height: auto;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: auto;
   }
`

export const CalendarIcon = styled.img.attrs({
   src: assets.CALENDAR
})`
   position: absolute;

   top: 10px;
   left: 14px;
`
